// #790 — общая цель возврата для кнопки «Вернуться к себе» и авто-завершения.
// Id сотрудника читается ДО применения сессии админа, capabilities — после.
import { isUserAdmin, type ViewerCapabilities } from '@/services/rbac'
import type { RouteLocationRaw } from 'vue-router'

export function impersonationReturnRoute(
  employeeId: number | null | undefined,
  capabilities: ViewerCapabilities,
): RouteLocationRaw {
  // Нет права на раздел — route-guard всё равно не пустит.
  if (!isUserAdmin(capabilities)) return { name: 'home' }
  if (employeeId === null || employeeId === undefined) return { name: 'admin-users' }
  return { name: 'admin-user', params: { id: employeeId } }
}
